import React from "react";
import Layout from "./views/layout/layout";

export default function App() {
	return <Layout />;
}
